import { gql } from '../types/generated';

export const UPDATE_PIPELINE_INPUT_CONFIG =
  gql(`mutation updatePipelineInputConfig($venueId: Int!, $feedType: MediaFeedType!, $pipelineInputConfig: PipelineInputConfig) {
    updatePipelineInputConfig(venueId: $venueId, feedType: $feedType, pipelineInputConfig: $pipelineInputConfig) {
      venueId
      feedTypeCode
      id
      inputLabel
      category
    }
  }`);
